<template>
  <div class="row my-4 border p-3 rounded-2 me-3">
    <div class="title d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center justify-content-start flex-column">
        <h5 class="text-book">
          {{ $t("The most reserved countries") }}
        </h5>
      </div>
      <div class="form-group w-25">
        <Multiselect
          v-model="nationalityValue_total_reves"
          :options="nationalities"
          :placeholder="$t('choose_nationality')"
          label="title"
          track-by="id"
          :clear-on-select="true"
          select-label=""
          :hide-selected="true"
          @keyup="searchNationality"
          @update:model-value="cityCountss"
        >
        </Multiselect>
      </div>
    </div>

    <div class="card">
      <Chart type="bar" :data="Total" :options="TwoTotal" class="Books" />
    </div>
  </div>
</template>

<script>
import Chart from "primevue/chart";
import Multiselect from "vue-multiselect";
import axios from "axios";
export default {
  data() {
    return {
      Total: null,
      TwoTotal: null,
      nationalities: [],
      nationalityValue_total_reves: "",
      total_profit: 0,
      cityTitles: [],
      cityCountssss: [],
      labels_cityCounts: [],
      labels_cityTitles: [],
      cities_complete_count: [],
      labels_cities_complete_count: [],
    };
  },
  async mounted() {
    // this.Total = this.fetcgTotal();

    this.TwoTotal = this.fetchTot();

    await this.cityCountss();
  },
  methods: {
    async searchNationality(event) {
      const searchText = {
        word: event == undefined ? "" : event.target.value,
      };
      await axios
        .post("/fetch_custom_countries", searchText)
        .then((res) => {
          // console.log(res.data.data.data, "searchNationality");
          this.nationalities = res.data.data.data;
        })
        .catch((err) => console.log(err));
    },
    fetcgTotal() {
      const documentStyle = getComputedStyle(document.documentElement);

      return {
        labels: this.labels_cityTitles,
        datasets: [
          {
            label: this.$t("The Countries"),
            backgroundColor: documentStyle.getPropertyValue("--blue-500"),
            borderColor: documentStyle.getPropertyValue("--blue-500"),
            data: this.labels_cityCounts,
          },
        ],
      };
    },
    fetchTot() {
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue("--text-color");
      const textColorSecondary = documentStyle.getPropertyValue(
        "--text-color-secondary"
      );
      const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

      return {
        indexAxis: "y",
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: {
          legend: {
            labels: {
              color: textColor,
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: textColorSecondary,
              font: {
                weight: 500,
              },
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            ticks: {
              color: textColorSecondary,
            },
            grid: {
              color: surfaceBorder,
              drawBorder: false,
            },
          },
        },
      };
    },
    async cityCountss() {
      const formData = new FormData();
      formData.append(
        "country_id",
        this.nationalityValue_total_reves.id == undefined
          ? 598
          : this.nationalityValue_total_reves.id
      );
      const res = await axios.post("/most_visit_flight", formData);
      // console.log(res.data, "wwww");
      this.labels_cityTitles = res.data.cityTitles;
      this.labels_cityCounts = res.data.cityCounts;

      // this.labels_cityTitles.forEach((label) => {
      //   this.cityTitles.push(label);
      // });
      // this.labels_cityCounts.forEach((book) => {
      //   this.cityCountssss.push(book);
      // });

      getComputedStyle(document.documentElement);

      this.Total = this.fetcgTotal();
    },
  },
  components: {
    Chart,
    Multiselect,
  },
};
</script>

<style lang="scss" scoped>
.text_point {
  color: #656b78;
  font-family: "regular";
  font-size: 0.8rem;
  margin: 0.5rem 0 0.5rem 0;
}
.bg-img {
  background: #0a909b;
}
.point {
  color: #0b1427;
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  align-content: center;
  justify-content: flex-end;
  flex-direction: row-reverse;
}
.p-chart.h-80 {
  min-height: 28dvh;
}
.linechart {
  min-height: 28dvh;
}
.text-book {
  color: #0b1427;
  font-weight: bold;
  font-size: 1.2rem;
}
.Books {
  min-height: 28dvh;
  max-height: 28dvh;
  overflow-y: auto;
}
.text-point {
  color: #656b78;
  font-family: "regular";
  font-size: 1rem;
}
.points {
  color: #0b1427;
  font-size: 2rem;
  font-family: "bold";
}
thead {
  background-color: #eef4f4 !important;
  th.text-center {
    padding: 0.8rem;
  }
}
.pendding {
  color: #c57016;
}
.cancel {
  color: #e23535;
}
.accept {
  color: #2a8f6f;
}
.initial {
  color: #1664b8;
}
</style>
